import { createContext, useState } from "react"
import ModalWrapper from "../components/ModalWrapper"
import LoginModal from "../components/LoginModal"

export const LoginModalContext = createContext()

export const LoginModalContextProvider = ({ children }) => {

    const [loginModalOpen, setLoginModalOpen] = useState(false)

    const value = {
        loginModalOpen,
        setLoginModalOpen
    }

    return (
        <LoginModalContext.Provider value={ value }>
            <ModalWrapper
                show={loginModalOpen}
                onHide={() => setLoginModalOpen(false)}
            >
                <LoginModal
                    onHide={() => setLoginModalOpen(false)}
                />
            </ModalWrapper>
            {children}
        </LoginModalContext.Provider>
    )

}